<formio-select-episode-dialog
    *ngIf="displaySelectEpisodeDialog"
    [episodeRequired]="episodeRequired"
    [patientId]="currentPatientId"
    [restoreSelectControlState]="restoreSelectControlState"
    [restoreDuplicateCheakState]="restoreDuplicateCheakState"
    [restoreSelectedEpisode]="restoreSelectedEpisode"
    [episode]="currentEpisode"
    (onSkip)="onSkipOkEpisodeSelectDialog($event)"
    (onCancel)="onCancelEpisodeSelectDialog()">
</formio-select-episode-dialog>

<multi-user-form-create-instance-dialog
    *ngIf="displayMufCreateInstanceDialog"
    [episodeId]="currentEpisode ? currentEpisode.id : null"
    [patientId]="currentPatientId"
    [walkInId]="currentWalkInId"
    [multiUserFormDef]="currentMUFDef"
    [anonymousSelfRegForm]="anonymousSelfRegForm"
    [selfRegOrgUrl]="selfRegOrgUrl"
    [selfRegPatientId]="selfRegPatientId"
    [isMandatoryForm]="isMandatoryForm"
    (onCancel)="onCancelMufInstanceDialog()"
    (onCreate)="onCreateMufInstanceDialog($event)">
</multi-user-form-create-instance-dialog>

<formio-form-request-dialog
    *ngIf="displayNewFormRequestDialog"
    [patientId]="patientService.currentPatientId"
    [formRevisionId]="currentFormDef.activeRevision.id"
    [episodeId]="currentEpisode?.id"
    [isMandatoryForm]="isMandatoryForm"
    (onCancel)="onCancelFormRequestDialog()"
    (onCreate)="onCreateFormRequestDialog()">
</formio-form-request-dialog>

<formio-select-patient-dialog
    *ngIf="displaySelectPatientDialog"
    (onOk) = "onOkSelectPatientDialog($event)"
    (onCancel) ="displaySelectPatientDialog = false">
</formio-select-patient-dialog>



